// This is generated.  Alter it in blockGroups/workflowCriteriaElements/types/MultiPickerDropDownCriteria.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const distinct = require('lodash/uniq');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      tooltip,
      foreignNamespace,
      foreignRelation,
      dropdownDisplayProperties = [],
      inputDisplayProperties = [],
      required = false,
    } = hNode;

    const nestedProperties = distinct([
      ...dropdownDisplayProperties,
      ...inputDisplayProperties,
    ]).filter(Boolean);

    // Build TypeBox schemas for nested string properties
    const nestedTypeDef = nestedProperties.reduce(
      (soFar, propertyName) => {
        return {
          ...soFar,
          [propertyName]: Type.String({
            title: propertyName,
            'x-dataType': 'string',
            'x-propertyName': propertyName,
          }),
        };
      },
      {
        _id: Type.String({
          title: 'Unique ID',
          'x-dataType': 'string',
          'x-propertyName': '_id',
        }),
      },
    );

    // we could be on an update form, or on a new form, or nested somewhere
    // We just don't know what accessContext this would be enabling, nor how it is applied on a NS/REL
    // Security Modifiers (which would disabled certain accessContext) are processed generically
    // All we know is that Whatever propertyName is on this Criteria block
    // and how it is formatted.

    const requiredProps = ['_id', ...nestedProperties];
    const itemSchema = Type.Object(nestedTypeDef, {
      title: 'Item',
      'x-dataType': 'object',
      additionalProperties: false,
      required: requiredProps,
    });

    const inSchema = Type.Optional(
      Type.Array(itemSchema, {
        title: 'Test for inclusion',
        'x-dataType': 'array',
        'x-propertyName': '_in',
        'x-optional': !required,
      }),
    );

    const ninSchema = Type.Optional(
      Type.Array(itemSchema, {
        title: 'Test for exclusion',
        'x-dataType': 'array',
        'x-propertyName': '_nin',
        'x-optional': !required,
      }),
    );

    // Create main criteria object
    const criteriaSchema = Type.Object(
      {
        _in: inSchema,
        _nin: ninSchema,
      },
      {
        'x-id': id,
        title: title,
        'x-tooltip': tooltip,
        'x-propertyName': `${foreignNamespace}:${foreignRelation}`,
        'x-dataType': 'object',
        'x-optional': !required,
        additionalProperties: false,
      },
    );

    const partialTypeDefinition = {
      [`${foreignNamespace}:${foreignRelation}`]: required
        ? criteriaSchema
        : Type.Optional(criteriaSchema),
    };

    return [{}, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'workflowCriteriaElements',
  'MultiPickerDropDownCriteria',
  module.exports,
);
